// AT-1118: de klantsite naar de bovenkant van het iframe brengen ná het laden.
//
// In een iframe scrollt de klantpagina en niet de shop: iframe-resizer maakt het iframe
// even hoog als de inhoud, dus er is geen scrollcontainer binnenin. Klik je onderaan de
// agenda op een knop, dan blijft de klantsite op die hoogte staan terwijl de nieuwe
// pagina bovenin begint -- je kijkt dan naar het midden van een pagina die je nog nooit
// gezien hebt.
//
// red-legacy.js loste dat op door op beforeunload een scrollbericht te sturen. Dat is
// één moment te vroeg: de ouderpagina springt terwijl de nieuwe pagina er nog niet is,
// dus je ziet eerst een sprong en daarna pas de navigatie. Hier gebeurt het ná het
// laden, zodat het één beweging is die op echte inhoud landt.
//
// Alleen als er ook echt iets te scrollen valt: staat de bovenkant van het iframe al in
// beeld, dan blijft alles staan.
(function () {
  if (window === window.top) return;

  function scrollNaarBoven() {
    if (typeof window.parentIFrame === 'undefined' || window.parentIFrame == null) return;

    window.parentIFrame.sendMessage({ type: 'scrollToTopOfIframe', offsetY: -50 });
  }

  // parentIFrame komt van iframe-resizer en is er niet meteen; even wachten tot het
  // kanaal open is in plaats van het bericht te laten verdwijnen.
  function zodraKlaar(poging) {
    if (typeof window.parentIFrame !== 'undefined' && window.parentIFrame != null) {
      scrollNaarBoven();
      return;
    }
    if (poging > 20) return;
    setTimeout(function () { zodraKlaar(poging + 1); }, 50);
  }

  window.addEventListener('load', function () { zodraKlaar(0); });
})();
